export default __webpack_public_path__ + "static/media/new_hampshire.0819a492.png";